import React from "react";
import underConstructionImg from "../../../assets/images/under-construction-1.jpg";

const ComingSoon = () => {
  return (
    <div className="w-full h-full flex justify-center items-center">
      {/* <div className="text-[rgba(1,1,1,0.6)] text-center px-0 min-[768px]:px-12">
        We are currently working hard to finalise this feature, we thank you for
        your patience and will let you know as soon as it is available.
      </div> */}
      <div className="flex justify-center">
        <img
          src={underConstructionImg}
          alt="under-Construction-img"
          className="w-3/4 h-auto block"
        />
      </div>
    </div>
  );
};

export default ComingSoon;
